import type { ReactNode } from 'react';
import { decodeEntities } from '@/lib/format';
import type { QualityAcceptanceProperty } from '@/types/buy';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * Приёмка по ГОСТу? Признак берётся из ответа; если его нет, приёмка считается «не по ГОСТу», когда у свойств заданы
 * пороги: иначе правила покупателя были бы показаны как «Только по ГОСТу».
 */
export function isByGost(flag: boolean | undefined | null, properties: readonly QualityAcceptanceProperty[]): boolean {
  if (flag != null) {
    return flag;
  }
  return !properties.some((property) => property.increaseValue != null || property.decreaseWeightValue != null);
}

/**
 * Значение строки «Приёмка по сорности, влажности, примесям» в условиях: «Только по ГОСТу» со значениями ГОСТа
 * через « · » либо согласованные правила «Если X превышает N %, снижение веса на M %». Одно для прайс-листа и для
 * предпросмотра сделки покупателя, чтобы покупатель видел перед сделкой ровно то, что задал в прайс-листе.
 */
export function acceptanceValue(byGost: boolean, properties: readonly QualityAcceptanceProperty[], t: Translate): ReactNode {
  if (byGost) {
    return (
      <>
        <div>{t('app.buy.terms.acceptanceGost')}</div>
        {properties.length > 0 ? (
          <div>
            {properties
              .map((property) => `${property.name}${property.gostValue ? ` ${decodeEntities(property.gostValue)}` : ''}`)
              .join(' · ')}
          </div>
        ) : null}
      </>
    );
  }
  return properties.map((property) => (
    <div key={property.name}>
      {t('app.buy.terms.qaRule', {
        name: property.name,
        limit: property.increaseValue,
        decrease: property.decreaseWeightValue,
      })}
    </div>
  ));
}
